module.exports = __webpack_public_path__ + "static/media/fort.f778df6a.mp3";